// Convenience to allow loading ./liteslider rather than ./liteslider/slider

import slider from './src/modules/slider.js';
export default slider;
